import { css } from 'styled-components';
import { Wrapper as DayWrapper, Price as DayPrice } from '@widgets/shared/components/CustomDatepicker/components/DatepickerDay/styles';
import { shakeXSmall } from '@widgets/shared/styles/animations';
export const datepickerWrapper = css `
  display: inline-block;
  padding: 0;
  border: 0;
  width: 100%;
`;
export const datepicker = css `
  border: none;
  display: flex;
  justify-content: space-between;
  position: relative;
  width: 100%;
  background-color: transparent;

  &.single-datepicker {
    justify-content: center;
  }

  .react-datepicker__triangle {
    display: none;
  }

  .react-datepicker__aria-live {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
    border-width: 0;
  }
`;
export const datepickerHeader = css `
  text-align: center;
  background-color: white;
  padding: 1rem 1rem 1.2rem ;
  position: relative;
`;
export const datepickerDayNames = css `
  display: flex;
  justify-content: space-around;
`;
export const datepickerDayName = css `
  width: 14%;
  max-width: 8rem;
  display: inline-flex;
  height: 1.1rem;
  justify-content: center;
`;
export const datepickerMonthContainer = css `
  float: none;
  width: 100%;
  //max-width: 38.5rem;
  background-color: #fff;
`;
export const datepickerMonth = css `
  margin: 0 auto;
  text-align: center;
  padding: 1.2rem 1rem 1.4rem;

  ${({ theme: { calendarDayWrapper } }) => calendarDayWrapper}
`;
export const datepickerWeek = css `
  display: flex;
  justify-content: space-around;
`;
export const datepickerDay = css `
  width: 14%;
  max-width: 8rem;
  height: 4.6rem;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
`;
export const dayWrapper = css `
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;
export const dayOutsideMonth = css `
  ${DayWrapper} {
    opacity: 0.5;

    ${DayPrice} {
      opacity: 0;
    }
  }
`;
export const dayDisabled = css `
  cursor: not-allowed;
  opacity: .45;

  ${DayPrice} {
    opacity: 0;
  }

  &:hover {
    background-color: transparent;
  }
`;
export const monthText = css `
  display: inline-block;
  width: 4rem;
  margin: 2px;
`;
export const inputContainer = css `
  position: relative;
  display: inline-block;
  width: 100%;
`;
export const decemberMonth = css `
  [aria-label="month  2022-12"],
  [aria-label^="month"][aria-label$="-12"],
  &.current-month-11 .react-datepicker__month-container {
    .react-datepicker__week .react-datepicker__day {
      &--outside-month {
        ${DayWrapper}.month-0 {
          opacity: 1;

          ${DayPrice} {
            opacity: 1;
          }
        }

        &.react-datepicker__day--selected,
        &.react-datepicker__day--in-selecting-range,
        &.react-datepicker__day--in-range {
          ${DayWrapper}.month-0 {
            opacity: 1;
          }
        }
      }
    }
  }
`;
export const lowAvailability = css `
  padding-bottom: 3.3rem;
  position: relative;

  &:after {
    content: "Hurry, last few tickets remaining!";
    color: #F3921E;
    position: absolute;
    width: 100%;
    bottom: 1.6rem;
    left: 0;
    padding: 0 1.5rem 0 4.2rem;
    background-image: url(data:image/svg+xml;base64,PHN2ZwogICAgd2lkdGg9IjI3cHgiCiAgICBoZWlnaHQ9IjI3cHgiCiAgICB2aWV3Qm94PSIwIDAgMjcgMjciCiAgICB2ZXJzaW9uPSIxLjEiCiAgICB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciCj4KICAgIDxwYXRoCiAgICAgICAgZD0iTTIuNDUsMTkuNjljMS4zLTEuMywzLjM4LTEuMzEsNC42Ni0uMDMsMS4yOCwxLjI4LDEuMjYsMy4zNy0uMDMsNC42NmwyLjMxLDIuMzEsMTEuMzEtMTEuMzFMMTEuNDUsNi4wNiwuMTQsMTcuMzhsMi4zMSwyLjMxWm0xOS4yOC01LjRsNC42My00LjYzLTIuMzEtMi4zMWMtMS4yMiwxLjIyLTMuMjUsMS4xOC00LjUzLS4xLTEuMjgtMS4yOC0xLjMyLTMuMzEtLjEtNC41M0wxNy4xMSwuNDFsLTQuNjMsNC42Myw5LjI2LDkuMjZaIgogICAgICAgIGZpbGw9IiNGMzkyMUUiCiAgICAgICAgZmlsbC1ydWxlPSJldmVub2RkIgogICAgLz4KPC9zdmc+Cg==);
    background-size: 1.6rem;
    background-repeat: no-repeat;
    background-position: 2rem -0.1rem;
    font-weight: 600;
    font-size: 1.4rem;
    line-height: 1.8rem;
    -webkit-animation-name: ${shakeXSmall};
    animation-name: ${shakeXSmall};
    -webkit-animation-duration: 7s;
    animation-duration: 7s;
    -webkit-animation-fill-mode: both;
    animation-fill-mode: both;
    -webkit-animation-iteration-count: infinite;
    animation-iteration-count: infinite;
    -webkit-animation-delay: 2s;
    animation-delay: 2s;
  }
`;
